module.exports = __webpack_public_path__ + "static/media/login_statement2.980e2631.svg";